import React from "react";
import Container from "@mui/material/Container";
import Slider from "react-slick";

import "./TestimonialsView.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Testimonials() {
  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 2,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 840,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 2,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 390,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
    ],
  };

  const testimonials = [
    {
      quote:
        "It's so easy to set up and works flawlessly. The developers were extremely helpful in helping to deploy a customised version to my store...",
      location: "United Kingdom",
      store: "Many Lenses",
    },
    {
      quote:
        "The AR works super-stable and shows our catalogue of available artworks perfectly placed in space. no additional editing necessary it's fully automated...",
      location: "Germany",
      store: "Nikolai Makarov",
    },
    {
      quote:
        "What genuinely distinguishes this app from a sea of competitors is the unparalleled level of support...",
      location: "Germany",
      store: "STILWAND",
    },
  ];

  return (
    <div className="TestimonialsView" style={{backgroundColor: "rgb(255, 253, 246)"}}>
      <Container maxWidth="xl">
        <div
          className="testimonials-container"
          style={{ paddingBottom: "40px", paddingTop: "20px" }}
        >
          <div className="text-title testimonials-title">Why Clients Love Us</div>
          <Slider {...settings}>
            {testimonials.map((data, index) => (
              <div
                key={index}
                className="testimonials-content"
                align="left"
              >
                <div
                  style={{
                    fontFamily: "Palatino",
                    fontSize: "4rem",
                    lineHeight: "4rem",
                    marginBottom: "-1rem",
                  }}
                >
                  “
                </div>
                <div
                  className="text-description"
                  style={{ fontStyle: "italic", width: "85%" }}
                >
                  {data.quote}
                </div>
                <h6 className="location" style={{ paddingTop: "20px" }}>{data.location}</h6>
                <h4 className="storeName">{data.store}</h4>
              </div>
            ))}
          </Slider>
        </div>
      </Container>
    </div>
  );
}

export default Testimonials;
